var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
import { Viewport, ViewSmall, ViewMedium, ViewLarge, ViewExtraLarge, defaultViewSizes } from '@shared-ui/viewport-context';
import { UitkIconSize } from 'uitk-react-icons';
import { PickerTriggerPlacementType } from '@shared-ui/global-navigation-picker';
import { PositionType } from 'uitk-react-menu';
import { UitkLayoutFlex } from 'uitk-react-layout-flex';
import { MobileAppDownloadButton } from '@shared-ui/customer-mobile-app-download-button';
import { HeaderShopMenu } from './header-shop-menu';
import { HeaderAccountMenu } from './account/header-account-menu';
import { getGCSectionData, getComponentsByViewport, isRuleApplicable } from './gc-section-data';
import { HeaderSecondaryNavigationElementLink } from './header-secondary-navigation-element-link';
import { SharedUIPickerWrapper } from '../common/picker/shared-ui-picker-wrapper';
import { LocaleSelector } from '../common/picker/locale-selector';
import { HeaderMenu } from './header-menu';
var HeaderSecondaryNavigationBar = /** @class */ (function (_super) {
    __extends(HeaderSecondaryNavigationBar, _super);
    function HeaderSecondaryNavigationBar() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    HeaderSecondaryNavigationBar.prototype.render = function () {
        var _a = this.props, analytics = _a.analytics, context = _a.context, page = _a.page, l10n = _a.l10n, globalComponentsContext = _a.globalComponentsContext, minimal = _a.minimal;
        var secondaryNavLinksSection = getGCSectionData(globalComponentsContext, 'header', 'secondaryNavLinks');
        if (!secondaryNavLinksSection || !secondaryNavLinksSection.sectionData) {
            return null;
        }
        var renderShopMenu = function (item) {
            var menuLinks = item.data;
            var menuItems = menuLinks.map(function (link) { return ({
                id: link.id,
                analytics: analytics.setupTracker(link.trackingEvent),
                className: 'uitk-list-item',
                label: link.text,
                href: link.url,
                typeAnchor: true,
                attributes: {
                    role: 'menuitem',
                    tabindex: 0
                },
                icon: link.iconName
            }); });
            return menuItems.length > 0 ? (React.createElement(Viewport, { key: item.id },
                React.createElement(ViewSmall, { key: item.id },
                    React.createElement(HeaderShopMenu, { id: "gc-custom-header-nav-bar-shop-menu", menuId: "ShopTravel", menuItems: menuItems, analytics: analytics, position: PositionType.RIGHT, shopMenuLabel: item.text, iconSize: UitkIconSize.MEDIUM, key: item.id })),
                React.createElement(ViewMedium, null))) : null;
        };
        var renderAccountMenu = function (item) { return (React.createElement(HeaderAccountMenu, { context: context, analytics: analytics, page: page, l10n: l10n, position: PositionType.RIGHT, menu: item, key: item.id })); };
        var renderMenu = function (item) { return (React.createElement(HeaderMenu, { key: item.id, menu: item, position: PositionType.RIGHT, width: 375, analytics: analytics })); };
        var renderPicker = function (item) { return (React.createElement(SharedUIPickerWrapper, { key: item.id, pickerTriggerPlacementType: PickerTriggerPlacementType.NAV_LINK })); };
        var renderLocaleSelector = function (item) { return (React.createElement("div", { key: item.id },
            React.createElement(LocaleSelector, { position: "Header" }))); };
        var renderMobileAppDownloadButton = function (item) { return (React.createElement("div", { id: "mobile-app-download-button", key: item.id },
            React.createElement(MobileAppDownloadButton, { key: item.id, inputs: {} }))); };
        var renderByElement = function (item) {
            var _a;
            switch (item.type) {
                case 'link-v2':
                    if (item.id === 'listYourProperty') {
                        var pageName = (_a = page === null || page === void 0 ? void 0 : page.pageName) !== null && _a !== void 0 ? _a : 'HomePage';
                        if (item.url.includes('{PAGE_NAME}')) {
                            // eslint-disable-next-line no-param-reassign
                            item.url = item.url.replace('{PAGE_NAME}', pageName);
                        }
                        else {
                            // eslint-disable-next-line no-param-reassign
                            item.url = item.url.replace('utm_campaign=pwa-header', "utm_campaign=".concat(pageName));
                        }
                    }
                    return (React.createElement(HeaderSecondaryNavigationElementLink, { l10n: l10n, secondaryElementData: item, key: item.id, showText: item.showText, showIcon: item.showIcon }));
                case 'menu':
                    if (item.id === 'shopTravel') {
                        return renderShopMenu(item);
                    }
                    return renderAccountMenu(item);
                case 'menu-v2':
                    return renderMenu(item);
                case 'picker':
                    return renderPicker(item);
                case 'language-links':
                    return renderLocaleSelector(item);
                case 'mobile-app-download-button':
                    return renderMobileAppDownloadButton(item);
                default: return null;
            }
        };
        var renderSecondaryNavSection = function (sectionData) {
            if (!minimal) {
                return (React.createElement("nav", { id: "secondaryNav", className: "navigation-bar", "aria-label": "secondary" },
                    React.createElement(UitkLayoutFlex, { alignItems: "center" }, sectionData.map(function (item) { return renderByElement(item); }))));
            }
            return null;
        };
        var getComponents = function (items, viewport) { return getComponentsByViewport(items, viewport)
            .map(function (item) { return (__assign(__assign({}, item), { showText: isRuleApplicable(item, 'showText', viewport) && !isRuleApplicable(item, 'hideText', viewport), showIcon: isRuleApplicable(item, 'showIcon', viewport) && !isRuleApplicable(item, 'hideIcon', viewport) })); }); };
        return (React.createElement(Viewport, null,
            React.createElement(ViewSmall, null, renderSecondaryNavSection(getComponents(secondaryNavLinksSection.sectionData, defaultViewSizes.SMALL))),
            React.createElement(ViewMedium, null, renderSecondaryNavSection(getComponents(secondaryNavLinksSection.sectionData, defaultViewSizes.MEDIUM))),
            React.createElement(ViewLarge, null, renderSecondaryNavSection(getComponents(secondaryNavLinksSection.sectionData, defaultViewSizes.LARGE))),
            React.createElement(ViewExtraLarge, null, renderSecondaryNavSection(getComponents(secondaryNavLinksSection.sectionData, defaultViewSizes.EXTRA_LARGE)))));
    };
    return HeaderSecondaryNavigationBar;
}(React.PureComponent));
export { HeaderSecondaryNavigationBar };
//# sourceMappingURL=header-secondary-navigation-bar.js.map